<template>
  <div class="chat-box">
    <content-box/>
    <transition name="slideUp">
      <h1 v-if="sec30" class="timer-right-top">剩下 {{remainingTime}} 秒</h1>
    </transition>
    <transition name="slideUp">
      <typing-bar v-if="linked" />
    </transition>
  </div>
</template>
<script>
import typingBar from './typingBar';
import contentBox from './contentBox';
import { mapState, mapGetters, mapMutations } from 'vuex';
const TITLE = 'SoulMatch - 速配';
export default {
  name: 'chat-box',
  components: { typingBar, contentBox },
  computed: {
    ...mapState('chat', ['sec30', 'message', 'linked']),
    ...mapGetters('chat', ['remainingTime'])
  },
  data() {
    return {
      notificationMusic:new Audio('./static/sound/unconvinced.mp3'),
      leaveMusic:new Audio('./static/sound/solemn.mp3'),
      notSee: 0, //未讀訊息
      userOut: false, // 使用者是否在視窗
      intervalerID: 0
    };
  },
  sockets: {
    connect() {
      this.messageInitial();
      //this.message = [];
      this.messagePush({
        time: Date.now(),
        who: 'system',
        text: '等待中',
        state: ''
      });
    },
    disconnect() {
      this.linkedChange(false);
      this.resetTimer();
      // remove countdown

      this.leaveMusic.play();
      this.scrollMessageToBottom();
    },
    linked() {
      this.linkedChange(true);
      /*
      if (channel !== 'Random') {
        this.$store.commit('messagePush', {
          time: Date.now(),
          who: 'system',
          text: channel,
          state: ''
        });
      }*/
      this.messageSplice();
      this.messagePush({
        time: Date.now(),
        who: 'system',
        text: 'Soul...Match 配對成功',
        state: ''
      });
      this.notificationMusic.play();
      this.startCount(); //timer scope function ref outside socket object

      this.scrollMessageToBottom();
    },
    message(m) {
      if (this.userOut) {
        this.notSee += 1;
        document.title = `(${this.notSee}) ${TITLE}`;
      }
      this.messagePush({
        time: m.time,
        who: m.who,
        text: m.text,
        sex: m.sex,
        state: ''
      });
      this.notificationMusic.play();
      this.scrollMessageToBottom();
    },
    unlinked() {
      this.resetTimer();

      this.messagePush({
        time: Date.now(),
        who: 'system',
        text: '對方已離開',
        state: ''
      });
      this.$socket.close();
    },
    sendSuccess(ts) {
      this.messageSuccess(ts);
    },
    readedCallback() {
      this.notSee = 0;
      document.title = TITLE;
    }
  },
  methods: {
    ...mapMutations('chat', [
      'linkedChange',
      'messagePush',
      'messageSplice',
      'messageInitial',
      'messageSuccess',
      'sec30set',
      'clearTimer',
      'remainingMinus'
    ]),
    resetTimer() {
      this.clearTimer(this.intervalerID);
      this.sec30set(false);
      //this.thirtySecond = false;
    },
    startCount() {
      this.intervalerID = setInterval(() => {
        //這裡用arrow才能拿到remaining time
        this.remainingMinus();
        //state.timer.remainingTime--;
        if (this.remainingTime === 0) {
          this.resetTimer();
          this.messagePush({
            text: '時間到囉，已斷開連接。',
            who: 'system',
            time: Date.now()
          });
          this.$socket.close();
        }
        if (this.remainingTime % 60 === 0) {
          this.messagePush({
            text: `系統提示：剩下 ${this.remainingTime / 60} 分鐘`,
            who: 'system',
            time: Date.now()
          });
          this.scrollMessageToBottom();
        }
        if (this.remainingTime === 30) {
          this.sec30set(true);
          //              this.thirtySecond = true;
          this.messagePush({
            who: 'system',
            time: Date.now(),
            text: '系統提示：剩下 30 秒'
          });
          this.scrollMessageToBottom();
        }
      }, 1000);
    },
    scrollMessageToBottom() {
      let content = document.querySelector('.content');
      this.$nextTick().then(() => {
        content.scrollTop = content.scrollHeight;
      });
    }
  },
  mounted() {
    ///For已讀功能
    window.onfocus = () => {
      this.userOut = false;
      this.notSee = 0;
      document.title = TITLE;
    };
    window.onblur = () => {
      this.userOut = true;
    };
  }
};
</script>

<style lang="scss" scoped>
.rotate-enter-active,
.rotate-leave-active {
  //  transition: margin-left 1s ease-in-out;
  //  transition: max-width 0.5s ease-in-out;
  transition: all 0.5s ease;
  transform: rotate(0deg);
}

.rotate-enter,
.rotate-leave-to {
  // margin-left: -260px;
  transform: rotate(0deg);
  opacity: 0;
}

.rotate-enter-to,
.rotate-leave {
  //margin-left: 0px;
  transform: rotate(30deg);
  opacity: 0.6;
}

.slideUp-enter-active,
.slideUp-leave-active {
  //  transition: margin-left 1s ease-in-out;
  //  transition: max-width 0.5s ease-in-out;
  transition: all 0.5s ease;
  transform: translateY(50px);
}

.slideUp-enter,
.slideUp-leave-to {
  // margin-left: -260px;
  transform: translateY(50px);
}

.slideUp-enter-to,
.slideUp-leave {
  //margin-left: 0px;
  transform: translateY(0px);
}

.timer-right-top {
  position: fixed;
  top: 50px;
  right: 10px;
  border-bottom: 5px solid red;
  border-bottom-right-radius: 1em;
  text-align: center;
  padding: 10px;
  font-weight: bold;
  color: red;
  opacity: 0.6;
  font-size: 16px;
}

.chat-box {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}
</style>
